<style lang="stylus" scoped>
@import "./cardMap.stylus";
.title
  span
    margin 0px 15px
    border-bottom 3px solid transparent
    color #999999
    display inline-block
    height auto 
    line-height 2
  span.active
    border-color #336CAF
    color #326DAF
.mark
  position fixed
  top 0 
  left 0
  right 0
  bottom 0
  display flex
  background rgba(0,0,0,0.7)
  z-index 100
  .circle
    margin auto
.map-area
  margin-top 20px
</style>

<template>
  <div class="home-main">
    <div class="map-data">
      <div class="map-area">
        <home-map :city-data="cityData" :time="timeSection" :dataType='dataType' :title='title' ></home-map>
      </div>
      <map-card :time='timeSection' :changeType='changeType'></map-card>
    </div>
  </div>
</template>

<script>
  import homeMap from "./components/map.vue";
  import mapCard from "./components/mapCard.vue";

  import http from '@/api/cardData'
  import cityData from "./map-data/get-city-value.js";
  import Cookies from "js-cookie";
  export default {
    name: "home",
    components: {
      homeMap,
      mapCard,
    },
    data() {
      return {
        timeSection: [new Date(new Date()*1-30*24*3600*1000)*1,new Date(new Date()*1-0*24*3600*1000)*1],
        cityData: [],
        areaList: [], //省列表
        dataType:'6',//点击省份详情列表
        title:0,//地图标题
        tab:0,
        progressNum:0,//进度条进度
        mark:false,//是否显示遮罩层
      };
    },
    watch:{
      'timeSection':function(value,oldValue){
        this.initData()
      },
    },
    computed: {
      'allTab':function(){
        return this.$store.state.app.tab
      },
      'titleArr':function(){
        return this.$store.state.app.titleArr
      },
    },
    created() {
      this.initData()
    },
    methods: {
      changeType( { num, title } ) {
        this.dataType = num;
        this.title = title;
      },
      initData() {
      let that = this;
      http[that.tab].timeChange().then(e=>{
        let data = e.data;
        that.areaList = data.areaList;
      });
      }
    },
  };
</script>
